import { render, staticRenderFns } from "./NewAdminMenu.vue?vue&type=template&id=26c82610&"
import script from "./NewAdminMenu.vue?vue&type=script&lang=js&"
export * from "./NewAdminMenu.vue?vue&type=script&lang=js&"
import style0 from "./NewAdminMenu.vue?vue&type=style&index=0&id=26c82610&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports